const Keyboard = require('PSKeyboardController');
let rigger; 
cc.Class({
    extends: cc.Component,

    properties: {
    },


    start () {

        rigger = window.PSGames.CommonAPI.Rigger;

        this.keys = [
            'digit1',
            'digit2',
            'digit3',
            'digit4',
            'digit5',
            'digit6',
            'digit7',
            'digit8',
            'digit9',
            'digit0',
            'keyq',
            'keyw',
            'keye',
            'keyr',
            'keyt',
            'keyy',
            'keyu',
            'keyi',
            'keyo',
        ];
        this.demo = this.node.getComponentInChildren('DemoController');
        // eslint-disable-next-line no-underscore-dangle
        this.demo._showbutton.normalColor.a = 0;
        this.node.opacity = 0;
        this.scheduleOnce(() => {
            this.node.opacity = 255;
        }, 0.1);

        this.names = rigger.listCheats();
        
        Keyboard.enableHandlers(this.keys);
        Keyboard.registerUIHandlers(this.keys, (data) => {
            const index = this.keys.indexOf(data.code.toLowerCase());
            
            if (index < this.names.length) {
                this.demo.callback(null, this.names[index]);
            }

        });
    }


});
